/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css } from "@panda/css";

export const tagList = css({
	display: "flex",
	flexWrap: "wrap",
	gap: "eds.dimension.16",
	//minHeight: "eds.dimension.32",
	mdDown: {
		"& .cosmos-text": {
			flex: "1 1 100%",
			paddingBlockEnd: "eds.dimension.8",
		},
	},
});
